import type { IAppState } from '../common/state';

export const rootStateBranchSelector =
  <RootStateBranchName extends keyof IAppState>(rootStateBranchName: RootStateBranchName) =>
  (state: IAppState): IAppState[RootStateBranchName] =>
    state[rootStateBranchName];
